module.exports = __webpack_public_path__ + "img/FruitNinjas.56ae44b6.svg";